import { render, staticRenderFns } from "./headImg.vue?vue&type=template&id=1e6a8528&scoped=true"
import script from "./headImg.vue?vue&type=script&lang=js"
export * from "./headImg.vue?vue&type=script&lang=js"
import style0 from "./headImg.vue?vue&type=style&index=0&id=1e6a8528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6a8528",
  null
  
)

export default component.exports